import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthProvider";
import { NotificationProvider } from "./context/NotificationContext";
import "./index.css";
import { QualityDataProvider } from "./context/QualityDataContext";
import { RecommendationProvider } from "./context/RecommendationContext";
import { SelectTagProvider } from "./context/SelectTagContext";
import { LoadingProvider } from "./context/LoadingContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <QualityDataProvider>
        <LoadingProvider>
          <NotificationProvider>
            <SelectTagProvider>
              <RecommendationProvider>
                <App />
              </RecommendationProvider>
            </SelectTagProvider>
          </NotificationProvider>
        </LoadingProvider>
      </QualityDataProvider>
    </AuthProvider>
  </BrowserRouter>
);
